import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { api } from '../../../common';

export enum ConnectionStatus {
  Connected = 'Connected',
  Disconnected = 'Disconnected',
  Synced = 'Synced',
  SyncFailed = 'Sync Failed',
}

export enum IsConnectedStatus {
  connected = 'connected',
  disconnected = 'disconnected',
}

export interface QBEvent {
  date: string;
  details: string;
  status?: ConnectionStatus;
}

export interface QuickbookStatus {
  currentStatus: IsConnectedStatus;
  connectedEvent?: QBEvent[];
  disconnectedEvent?: QBEvent[];
  syncedEvent?: QBEvent[];
  syncFailedEvent?: QBEvent[];
  email: string;
  companyName?: string;
}

@Injectable({ providedIn: 'root' })
export class QuickbooksService {
  private readonly http = inject(HttpClient);

  qbConnect(): Observable<string> {
    return this.http.get(`${api}/qb/oauth2/authUri`, {
      responseType: 'text' as 'text',
    });
  }

  sendParams(queryParams: Record<string, string>): Observable<void> {
    const urlQueryParams = new URLSearchParams(queryParams).toString();
    return this.http.get<void>(`${api}/qb/oauth2/callback?${urlQueryParams}`);
  }

  public status(): Observable<QuickbookStatus> {
    return this.http.get<QuickbookStatus>(`${api}/qb/status`);
  }

  sync(): Observable<QuickbookStatus> {
    return this.http.post<QuickbookStatus>(`${api}/qb/sync`, {});
  }

  disconnect(): Observable<void> {
    return this.http.post<void>(`${api}/qb/disconnect`, {});
  }
}
